export default __webpack_public_path__ + "static/media/incoming-danger.856b01af.svg";